<!-- 

This is a collapseable component that abstracts the series of components from the BootstrapVue library
that performs this single action. Provide the title text, actual text, and a group name that
serves to let only one collapsible be open at one time

 -->

<template>
  <div>
    <div class="row bg-dark text-light p-3">
      <div class="show-cursor col-10" v-b-toggle="toggle">
        {{title}}
      </div>

      <i class="material-icons col-2 show-cursor text-right" v-b-toggle="toggle">{{iconState}}</i>
    </div>

    <b-collapse :id="toggle" :accordion="group" role="tabpanel">
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>

import bCollapse from 'bootstrap-vue/es/components/collapse/collapse'
import bToggle from 'bootstrap-vue/es/directives/toggle/toggle'

export default {
  directives: {
    bToggle
  },
  components: {
    bCollapse
  },
  data () {
    return {
      iconState: "expand_more"
    }
  },
  computed: {
    toggle: function() {
      return this.slotId.toString()
    }
  },
  props: ['title', 'group', 'slotId'],
  mounted: function() {
    this.toggleArrow()
  },
  methods: {
    toggleArrow: function() {
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        if (this.slotId == collapseId) {
          if (isJustShown) {
            this.iconState = "expand_less"
          } else {
            this.iconState = "expand_more"
          }
        } 
      })
    }
  }
}

</script>

<style>
</style>